import Breadcrumbs from 'components/atomic/Breadcrumbs'
import MetaSeo from 'components/atomic/MetaSeo'
import { ListingAbbonamento } from 'react-components/organisms'
import { PAGINEDETAIL, ABBONAMENTI } from 'utils/endpoint'
import { api } from 'utils'

const RivisteAll = ({ pagina, abbonamenti }) => {
  return (
    <main className="riviste-page">
      <MetaSeo seo={pagina.seo} />
      <div className="w-container-fluid">
        <div className="w-container">
          <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
        </div>

        <section className="riviste-page__header">
          <div className="w-container">
            <h1 className="riviste-page__description">{pagina.descrizione}</h1>
          </div>
        </section>
      </div>
      <section className="riviste-page__list-section ">
        <ListingAbbonamento abbonamenti={abbonamenti} />
      </section>
    </main>
  )
}

export const getStaticProps = async () => {
  const pageResponse = await api.get(PAGINEDETAIL, {
    params: {
      chiave: 'riviste-all',
    },
  })
  const pagina = await pageResponse.data

  const { data } = await api.get(ABBONAMENTI, {
    params: { rinnovo: false },
  })

  const toolbarProps = { toolbarPage: pagina }

  return { props: { pagina, abbonamenti: data, ...toolbarProps }, revalidate: 60 * 2 }
}

export default RivisteAll
